import React, {useState, useContext, Suspense, lazy, useEffect, useRef, useMemo} from 'react';
import {Outlet,Route,Routes,useLocation,Navigate} from 'react-router-dom';
import PcLayout from '../layout/pc';
import '../view/comom.scss'

import LoginPage from '@view/page/LoginPage';

import Dashboard from '@view/page/Dashboard';
import PersonalCenter from "@view/page/personalCenter";
import MasterShoot from "@view/page/masterShoot"
import MasterDelivery from "@view/page/MasterDelivery"
import Requirement from "@view/page/Requirement"

import Sidebar from '@view/compoents/sidebar/sidebar'


function HomeLayout () {
    const location = useLocation();
    const [isPersonalCenter, setPersonalCenter] = useState(false)
    useEffect(() => {
        if( location.pathname == '/home/homemain/personalCenter') {
            setPersonalCenter(true)
        } else {
            setPersonalCenter(false)
        }
    }, [location.pathname]);


    return (
        <div className='Home_main'>
            { !isPersonalCenter && <Sidebar></Sidebar>}
            <div className='main_right'>
                <Outlet />
            </div>
        </div>
    )
}

export default function PcRoute () {
    const location = useLocation();

    useEffect(() => {
        const target = document.getElementById('topView')
        if (target) target?.scrollIntoView()
    }, [location.pathname])

    return (
        <Routes>
            <Route path="/" element={<PcLayout />}>
                <Route path="" element={<LoginPage />} />
                <Route path="home/" element={<div style={{height: 'calc(100% - 56px)', overflow: 'hidden', position: 'relative'}}><Outlet /></div>}>
                    <Route path="homemain/*" element={<HomeLayout/>}>
                        <Route path="dashboard" element={<Dashboard />} ></Route> 
                        <Route path="masterDeliver" element={<MasterDelivery />} ></Route> 
                        <Route path="masterShoot" element={<MasterShoot />} ></Route> 
                        <Route path="personalCenter" element={<PersonalCenter key={'personal'}/>}></Route>
                        <Route path="requirement" element={<Requirement />} ></Route>
                        <Route path="*" element={<Navigate replace to="/" />} />
                    </Route>
                    <Route path="*" element={<Navigate replace to="/" />} />
                </Route>
            </Route>
        </Routes>
    )
}